// extracted by mini-css-extract-plugin
module.exports = {"target":"target___1fEzG","outerSpan":"outerSpan___z_2ps","correctDND":"correctDND___1sKoJ","incorrectDND":"incorrectDND___1NH9R"};